<template>
    <div class="sn-table">
        <vs-card class="shadow-none">
            <slot name="panel"></slot>
        </vs-card>
        <vs-table :search="search" :data="dataTable" :sst="sst" hoverFlat :stripe="stripe" @sort="handleSort" :noDataText="$t('table.No_data_available')">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex items-center data-list-btn-container header mb-4 justify-between offers__buttons w-full">
                    <slot name="header"></slot>
                </div>

                <div class="flex justify-between w-full paginateBlock">
                    <div class="flex items-center justify-between">
                        <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 items-per-page-handler">
                            <div class="p-4 border border-solid flex d-theme-border-grey-light rounded-full flex-grow d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2 whitespace-no-wrap">
                                    {{ (page - 1) * limitNum + 1 }} - {{ (page - 1) * limitNum + limitNum }} of {{ allItems }}
                                </span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item v-for="(item, index) of itemsPagination" :key="index" @click="changeLimit(item)">
                                    <span>{{ item }}</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>

                    <div class="flex items-center">
                        <vs-pagination
                            ref="pagination"
                            color="primary"
                            v-model="pageNum"
                            :total="totalPage"
                            :max="refPaginationPagesLength < 9 ? refPaginationPagesLength : 9"
                        />
                    </div>
                </div>
            </div>

            <template slot="thead">
                <vs-th v-for="(head, index) of heads" v-if="head.display && isPermission(head.can)" :sort-key="head.sortKey" :key="index">
                    {{ $t(head.name) }}
                </vs-th>
            </template>

            <template slot-scope="{data}" v-if="data.length">
                <tbody>
                <template v-for="(tr, ind) of data">
                    <vs-tr :key="ind">
                        <vs-td v-if="head.display && isPermission(head.can)" v-for="(head, index) of heads" :key="index">
                            <slot :name="head.value" v-bind="{[head.value]: tr}">
                                <div class="whitespace-no-wrap">{{ tr[head.value] ? tr[head.value] : '-' }}</div>
                            </slot>
                        </vs-td>
                    </vs-tr>
                </template>
                </tbody>
            </template>
        </vs-table>

        <div class="paginateBlock">
            <div class="mt-4">
                <vs-pagination
                    ref="pagination2"
                    color="primary"
                    v-model="pageNum"
                    :total="totalPage"
                    :max="refPaginationPagesLength < 9 ? refPaginationPagesLength : 9"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {fixHindusPagination} from '@/utils/mixins'

export default {
    mixins: [fixHindusPagination],
    data() {
        return {
            pageNum: 1,
            limitNum: 1,
            refPaginationPagesLength: 0
        }
    },

    props: {
        allItems: { type: Number, required: true },
        page: { type: Number, default: 1 },
        itemsPagination: { type: Array, required: true },
        viewLimit: { type: Number, required: true },
        heads: { type: Array, required: true },
        stripe: { type: Boolean, default: false },
        dataTable: { type: Array, required: true },
        search: { type: Boolean, default: false },
        sst: { type: Boolean, default: false }
    },

    computed: {
        permission() {
            return this.$store.state.userPermissions
        },

        totalPage() {
            return Math.ceil(this.allItems / this.viewLimit)
        }
    },

    watch: {
        page(page) {
            this.pageNum = page
        }
    },

    methods: {
        isPermission(name) {
            if (name) {
                name = name.split('.')
                if (this.permission[name[0]]) {
                    return this.permission[name[0]].includes(name[1])
                } else {
                    return false
                }
            }
            return true
        },

        changeLimit(data) {
            this.limitNum = data
            this.$emit('limit', data)
        },

        handleSort(a, b) {
            this.$emit('sort', {name: a, action: b})
        }
    },

    mounted() {
        const divs = document.querySelectorAll('.con-vs-pagination')
        let num = this.pageNum
        for (const div of divs) {
            div.addEventListener('click', event => {
                if (num !== this.pageNum) {
                    this.$emit('page', this.pageNum)
                    num = this.pageNum
                }
            })
        }

        if (this.page) {
            this.pageNum = this.page
        }
        this.limitNum = this.viewLimit

        this.$watch(
            () => {
                if (this.$refs.pagination) {
                    return this.$refs.pagination.pages
                }
            },
            value => {
                if (value) {
                    this.$set(this, 'refPaginationPagesLength', value[value.length -1])

                    Object.assign(this.$refs.pagination, {getPages: this.getPages(this.$refs.pagination)})
                    Object.assign(this.$refs.pagination2, {getPages: this.getPages(this.$refs.pagination2)})
                }
            }
        )
    }
}
</script>

<style lang="scss">
.sn-table {
    .search input {
        border-radius: 50px;
    }

    .vs-con-table .vs-table--header .vs-table--search {
        display: none !important;
    }

    .vs-pagination--ul {
        li {
            font-size: .8rem;
            width: 30px;
            height: 30px;
        }
    }

    .vs-card--content {
        padding: 0;
    }

    .vs-table--thead tr {
        background: none;
    }
}
</style>
